import { createSelector, createFeatureSelector, select } from '@ngrx/store';
import { State } from './valuations.reducer';
import { ValuationsFilter, ValuationsFund, ValuationsPortfolio } from './valuations.models';
import { DatesInterval } from '../../global/interfaces';
import { filter } from 'rxjs/operators';

export const selectValuationsState = createFeatureSelector<State>('valuations');

export const selectValuationsLoading = createSelector(selectValuationsState, (state: State) => state.loading);

export const selectValuationsDataLoading = createSelector(selectValuationsState, (state: State) => state.dataLoading);

export const selectValuationsDates = createSelector(selectValuationsState, (state: State) => state.dates);

export const selectValuationsDatesMin = createSelector(selectValuationsDates, (dates?: DatesInterval) => dates ? dates.min : undefined);

export const selectValuationsDatesMax = createSelector(selectValuationsDates, (dates?: DatesInterval) => dates ? dates.max : undefined);

export const selectValuationsFilter = createSelector(selectValuationsState, (state: State) => state.filter);

export const selectValuationsTypeFilter = createSelector(selectValuationsFilter, (filter: ValuationsFilter) => filter.type);

export const selectValuationsFundsFilter = createSelector(selectValuationsFilter, (filter: ValuationsFilter) => filter.funds);

export const selectValuationsFundFilter = createSelector(selectValuationsFilter, (filter: ValuationsFilter) => filter.fund);

export const selectValuationsPriceFilter = createSelector(selectValuationsFilter, (filter: ValuationsFilter) => filter.price);

export const selectValuationsFromFilter = createSelector(selectValuationsFilter, (filter: ValuationsFilter) => filter.from);

export const selectValuationsToFilter = createSelector(selectValuationsFilter, (filter: ValuationsFilter) => filter.to);

export const selectValuationsPortfolio = createSelector(selectValuationsState, (state: State) => state.portfolio);

export const selectValuationsFunds = createSelector(selectValuationsPortfolio, (state: ValuationsPortfolio) => state.funds);

export const selectValuationsPrices = createSelector(selectValuationsState, (state: State) => state.prices);

export const selectValuationsTotalPrices = createSelector(selectValuationsState, (state: State) => state.totalPrices);

/**
 * Combined selector used for Valuation Chart
 * Funds and Fund are different fields
 * Funds is used for Growth of Investment
 * Fund is used for Prices
 */
export const selectValuationsChartPayload = createSelector(
  selectValuationsPrices,
  selectValuationsTotalPrices,
  selectValuationsFunds,
  selectValuationsFundsFilter,
  selectValuationsFundFilter,
  selectValuationsPriceFilter,
  selectValuationsTypeFilter,
  selectValuationsDates,
  (prices, total, funds, filter, fund, price, type, dates) => {
    if (!prices.length || !total.length || !funds.length || !fund.length) {
      return undefined;
    }
    return { prices, total: total[0], funds, filter: { funds: filter, price, type, fund: fund[0] }, dates };
  }
);

export const selectValuationsPayloadFunds = createSelector(selectValuationsFunds, (funds: ValuationsFund[]) =>
  !funds.length ? undefined : funds.map(fund => fund.fundId).join(';')
);
